import { Dialog } from '@vitalsource/vstui';
import React from 'react';
import { withTextForward } from '../../config/withTextForward';
import { replaceStrings } from '../../config/replace-strings';
import withLocale from '../../config/withLocale';
import { replaceParams } from '../../../utils/strings';

export const VSTUI_DIALOG_TARGET = 'vstuiDialogTarget';

function VstuiDialog({
  isOpen,
  addCloseToPrimary,
  addCloseToSecondary,
  locale,
  titleParams,
  ...restProps
}) {
  const extraProps = {};

  function addClose(itemName) {
    const existingValue = { ...restProps[itemName] };
    if (existingValue) {
      const oldClick = existingValue.onClick;
      existingValue.onClick = e => {
        oldClick && oldClick(e);
        restProps.onClose();
      };
    }
    extraProps[itemName] = existingValue;
  }

  function fixButtonText(button) {
    if (allProps[button]) {
      return replaceStrings(locale, allProps[button]);
    }
    return null;
  }

  // title gets expanded to template by withTextForward
  if (titleParams) {
    extraProps.title = replaceParams(restProps.title, titleParams);
  }

  if (addCloseToPrimary) {
    addClose('primaryActionButton');
  }
  if (addCloseToSecondary) {
    addClose('secondaryActionButton');
  }

  const allProps = {
    ...restProps,
    ...extraProps,
  };

  allProps.primaryActionButton = fixButtonText('primaryActionButton');
  allProps.secondaryActionButton = fixButtonText('secondaryActionButton');

  return (
    <Dialog
      open={isOpen}
      onRequestClose={restProps.onClose}
      rootSelector={`#${VSTUI_DIALOG_TARGET}`}
      {...allProps}
    />
  );
}

/**
 * There are a lot of dialogs, and if all the dialogs mount right out of the
 * gate it leads to performance problems. vstui doesn't handle this, so I have to.
 * The two-step process is needed to trigger the enter animation.
 **/
class MountableDialog extends React.Component {
  state = {
    mounted: false,
    shown: false,
  };

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.isOpen) {
      return {
        mounted: true,
        shown: prevState.mounted,
      };
    }
    return {
      shown: false,
    };
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.mounted && !prevState.mounted) {
      this.setState({
        shown: this.props.isOpen,
      });
    }
  }

  render() {
    if (!this.state.mounted) {
      return null;
    }
    return <VstuiDialog {...this.props} isOpen={this.state.shown} />;
  }
}

export default withTextForward(withLocale(MountableDialog));
